export default __webpack_public_path__ + "static/media/No.6-1.20b0daa3.jpg";